import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.element.addEventListener("click", this.#onClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.#onClick);
  }

  #onClick = () => {
    const dialogId = this.element.getAttribute("aria-controls");
    const dialogEl = document.getElementById(dialogId);

    if (dialogEl == null) {
      console.error("Missing aria-controls attribute on dialog trigger", this.element);
      return;
    }
    dialogEl.dataset.dialogOpenValue = true;
  }
}
